module.exports = __webpack_public_path__ + "static/media/Forward_Arrow@3x.3c2c0472.png";